export const EstadosCobranzas = [
  { id: 11, nombre: 'Cobrado' },
  { id: 12, nombre: 'Vencido' },
  { id: 13, nombre: 'No cobrado' },
  { id: -1, nombre: 'Eliminado' },
];